






















































































/* General */
import Vue from 'vue'
import * as routerNames from '@/services/router/router.names'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { IPersonBase } from '@/api/types/response.types'
import { EEntities } from '@/types'
import {
  IMemberDataFromEntityLanding,
  INavMenuGroup,
} from '@/types/data-objects/global'

/* API */

export default Vue.extend({
  name: 'ProjectHomeHeaderOptions',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  props: {
    members: {
      type: Array as () => IPersonBase[],
      required: true,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    isKanban: {
      type: Boolean,
      default: false,
    },

    accountId: {
      type: Number,
      required: true,
    },

    projectId: {
      type: Number,
      required: true,
    },

    projectName: {
      type: String,
      default: '',
    },

    totalItemCount: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      EEntities,
      RouteAssistant,
    }
  },

  computed: {
    cachedMemberData(): IMemberDataFromEntityLanding {
      return this.$store.get('app/lastVisitedEntityLandingMemberData')
    },

    hasCachedMemberData(): boolean {
      return (
        this.cachedMemberData &&
        this.cachedMemberData.entityID === this.projectId
      )
    },

    menuList(): INavMenuGroup[] {
      const items = [
        {
          label: 'Manage',
          options: [
            {
              value: routerNames.PROJECT_SETTINGS_ASSIGN_PEOPLE,
              label: 'Add/Remove Users',
              icon: 'people',
            },
            ...(this.$permissions.isTieredPricingPlan
              ? [
                  {
                    value: routerNames.PROJECT_SETTINGS_ASSIGN_GUESTS,
                    label: 'Add/Remove Guests',
                    icon: 'people',
                  },
                ]
              : []),
            {
              value: routerNames.PROJECT_SETTINGS_CHECKLIST_TEMPLATES,
              label: 'Checklist Templates',
              icon: 'everything',
            },
            {
              value: routerNames.PROJECT_SETTINGS_DESCRIPTION_TEMPLATES,
              label: 'Description Templates',
              icon: 'description',
            },
            {
              value: routerNames.PROJECT_SETTINGS_MANAGE_WORKFLOW,
              label: 'Manage Workflow',
              icon: 'workflows',
            },
            {
              value: routerNames.PROJECT_SETTINGS_GENERAL_SETTINGS,
              label: 'General Settings',
              icon: 'cog',
            },
            {
              value: routerNames.PROJECT_SETTINGS_INTEGRATIONS,
              label: 'Integrations',
              icon: 'integrations',
            },
          ],
        },
      ]

      return items
    },
  },

  watch: {
    members() {
      this.cacheMemberDataFromEntityLanding()
    },
  },

  methods: {
    cacheMemberDataFromEntityLanding() {
      const data = {
        entityID: this.projectId,
        members: this.members,
      } as IMemberDataFromEntityLanding

      this.$store.set('app/lastVisitedEntityLandingMemberData', data)
    },
    sendToSettingsLink(value: string) {
      this.$router.push({
        name: value,
        params: {
          accountId: this.$route.params.accountId,
          id: this.$route.params.id,
        },
      })
    },
  },
})
